import styles from './index.module.css'

export const Footer = () => {
    const currentYear = new Date().getFullYear()

    return (
        <div className={`a-footer ${styles.a_footer}`}>
            &copy;{currentYear} PwC. All rights reserved. PwC refers to the PwC network and/or one or more of its member
            firms, each of which is a separate legal entity. Please see{' '}
            <a
                style={{ color: '#9E9E9E', textDecoration: 'underline' }}
                href="https://www.pwc.com/structure"
                target="_blank"
                rel="noopener noreferrer"
            >
                www.pwc.com/structure
            </a>{' '}
            for further details.
        </div>
    )
}
